<template>
  <div>
    <div class="white--text mb-4 section-title">Часто задаваемые вопросы</div>

    <v-card v-if="faq.length" class="radius-16">
      <v-expansion-panels v-if="faq.length">
        <v-expansion-panel v-for="(item, i) in faq" :key="i">
          <v-expansion-panel-header><b>{{item.question}}</b></v-expansion-panel-header>
          <v-expansion-panel-content>
            <span v-html="item.answer"></span>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card-text class="text-center" v-if="!faq.length && loading">
        <v-progress-circular
            class="mt-5"
            :width="3"
            color="#0075a8"
            indeterminate
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Faq',
  computed: {
    faq() {
      return this.$store.state.faq;
    },
  },
  mounted() {
    this.$store.dispatch('GetFaq');
  },
};
</script>

<style scoped>

</style>
